// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","active":"Footer_active__J1nhd","inner":"Footer_inner__QWbCb","portal":"Footer_portal__bics9"};